const $ = window.jQuery;
const $window = $window || $(window);

const Faqs = {

    init() {
        var $module = $('.Faqs');
        if (!$module.length)
            return;

        $module.each((index, element) => {
            this.each(element);
        });
    },

    each(element) {

        let $item = $(element);

        $item.on('click', '.Faqs__question', function (e) {
            let $q = $(this);
            let $btn = $q.find('button');
            let $arrow = $q.find('svg');
            let $a = $(this).next('.Faqs__answer');
            $a.toggle();
            $btn.toggleClass('text-purple-50 text-mauve');
            $arrow.toggleClass('-rotate-180 -rotate-0');
        });

    }

};

export default Faqs;